export function isMasterProduct(productTaxonomies: string[] | undefined): boolean {
  return productTaxonomies?.includes('/masterProduct') ?? false;
}
